import React from "react";
import { createInstance, OptimizelyProvider } from "@optimizely/react-sdk";
import { useEnv } from "store/env";
import { LogLevel } from "@optimizely/js-sdk-logging";
import { useAuth0 } from "@auth0/auth0-react";
declare global {
  interface Window {
    optimizelyDatafile?: object | string;
    optimizelyDatafileFallback: object | string;
  }
}
export const FlagProvider: React.FC = ({ children }) => {
  const { user } = useAuth0();
  const email = user ? user.email : "temp@email.com"; // Upon first render, user is undefined. This helps the app not crash.
  const { optimizelySdkKey } = useEnv();
  const preloadedFlags =
    window.optimizelyDatafile || window.optimizelyDatafileFallback;
  //Attributes must be coordinated with: https://app.optimizely.com/v2/projects/17165161924/audiences/attributes
  const optimizely = createInstance({
    sdkKey: optimizelySdkKey,
    logLevel: LogLevel.ERROR,
    errorHandler: {
      handleError: () => {}
    },
    datafile: preloadedFlags
  });
  return (
    <OptimizelyProvider
      optimizely={optimizely}
      user={{ id: email, attributes: { email: email } }}
    >
      {children}
    </OptimizelyProvider>
  );
};
